import RetirementInvestmentTopUpPage from '@/common/pages/(private)/(dashboard)/benefits/retirement-investment/[orderId]/top-up';

export default function Page() {
  return <RetirementInvestmentTopUpPage />;
}
